module.exports = __webpack_public_path__ + "static/media/ios-bicycle.edfaa92f.svg";